var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { CheckIcon } from '../icons/index.js';
import { FloatingWrapper } from '../utils/floating/index.js';
import { getValidChildren, runIfFn } from '../utils/index.js';
import { useAutocomplete } from './AutocompleteContext.js';
export const AutocompleteItems = forwardRef((props, ref) => {
    const { children, className, variant = 'default' } = props, rest = __rest(props, ["children", "className", "variant"]);
    const { isOpen, inputValue, getMenuProps } = useAutocomplete();
    const validChildren = getValidChildren(children);
    if (variant === 'unstyled') {
        return (React.createElement("ul", Object.assign({ className: clsx('bg-surface overflow-auto', 'focus-visible:ring-1 focus:outline-none', (!isOpen || (validChildren === null || validChildren === void 0 ? void 0 : validChildren.length) === 0) && 'hidden', className) }, getMenuProps(Object.assign({ open: isOpen, ref }, rest), { suppressRefError: true })), (() => {
            if (!isOpen) {
                return null;
            }
            if (!inputValue) {
                return (React.createElement(AutocompleteItemsEmpty, null, "Please enter a search query"));
            }
            return validChildren;
        })()));
    }
    return (React.createElement(FloatingWrapper, { open: isOpen, sameWidth: true, skipTransition: true },
        React.createElement("ul", Object.assign({ className: clsx('w-full bg-surface shadow-lg max-h-96 rounded-md text-base border border-line-subdued overflow-auto', 'focus-visible:ring-1 focus:outline-none', (!isOpen || (validChildren === null || validChildren === void 0 ? void 0 : validChildren.length) === 0) && 'hidden', className) }, getMenuProps(Object.assign({ open: isOpen, ref }, rest), { suppressRefError: true })), (() => {
            if (!isOpen) {
                return null;
            }
            if (!inputValue) {
                return (React.createElement(AutocompleteItemsEmpty, null, "Please enter a search query"));
            }
            return validChildren;
        })())));
});
export const AutocompleteItem = props => {
    const { value, children, disabled, index, className } = props, rest = __rest(props, ["value", "children", "disabled", "index", "className"]);
    const { selectedItem, getItemProps, highlightedIndex } = useAutocomplete();
    const selected = selectedItem === value;
    const active = highlightedIndex === index;
    return (React.createElement("li", Object.assign({ className: clsx(active
            ? 'text-content-hovered bg-surface-hovered'
            : 'text-content-subdued bg-surface', 'cursor-default select-none relative py-2 ps-3 pe-9', className) }, getItemProps(Object.assign({ item: value, index, disabled }, rest))),
        React.createElement(React.Fragment, null,
            React.createElement("span", { className: clsx(selected ? 'font-semibold' : 'font-normal', disabled ? 'opacity-50' : '', 'block truncate') }, runIfFn(children, {
                selected,
                active,
            })),
            selected ? (React.createElement("span", { className: clsx(active ? 'text-content-subdued' : 'text-content-subdued', 'absolute inset-y-0 end-0 flex items-center pe-4') },
                React.createElement(CheckIcon, { className: "h-5 w-5", "aria-hidden": "true" }))) : null)));
};
export const AutocompleteItemsEmpty = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: clsx('text-content', 'cursor-default select-none relative py-2 ps-3 pe-9', className) }, rest),
        React.createElement("span", { className: "font-normal block truncate" }, children)));
};
//# sourceMappingURL=AutocompleteItems.js.map